export default "__VITE_ASSET__DyStz_2Y__"